import Breakdown from "./Components/Breakdown/Breakdown";
import { TeamSettings } from "./Components/Settings/TeamSettings";
import { Baseline } from "./Components/Baseline/Baseline";
import { OnBoarding } from "./Components/OnBoarding";
import { Compare } from "./Components/Compare/Compare";
import { Drills } from "./Components/Drills/Drills";
import { Features } from "./Components/MarketingPages/Features";
import { About } from "./Components/MarketingPages/About";
import { Team } from "./Components/MarketingPages/Team";
import { Customers } from "./Components/MarketingPages/Customers";
import OnBoard from "./Components/Onboarding/OnBoard";
import Dashboard from "./Components/Dashboard";

import Main from "./sections/Hero";
import { Home } from "./views";
import { BlogDetail } from "./sections/Blogs/BlogDetail";
import BlogPost from "./sections/Blogs/BlogPost";
import { Login } from "./Components/Login"

import { GeneralReports } from "./Components/Report/GeneralReports.tsx";


export const ROUTES = [
  // { path: '/postdata', component:  PostData},
  // { path: '/teamdata', component:  TeamData},
  // { path: '/playerdata', component: PlayerData},
  { path: "/dashboard", element: <Dashboard /> },

  { path: "/breakdown/:date?", element: <Breakdown /> },
  { path: "/baseline", element: <Baseline /> },
  { path: "/compare", element: <Compare /> },
  { path: "/drills", element: <Drills /> },
  { path: "/settings", element: <TeamSettings /> },
  { path: "/reports", element: <GeneralReports /> },
  // { path: '/onboard', element: <OnBoard},
  // { path: '/login', element:Login},
  // { path: '/overview', element:Overview},
  { path: "/features", element: <Features /> },
  { path: "/about", element: <About /> },
  { path: "/team", element: <Team /> },
  { path: "/customer-success", element: <Customers /> },
  { path: "/on", element: <OnBoarding /> },
  { path: "/blog-detail", element: <BlogDetail /> },
  { path: "/", element: <Login/> },
  {
    path: "/maximizing-performance-georgia-tech-football",
    element: (
      <BlogPost article="https://docs.google.com/document/d/e/2PACX-1vTZRK08DqVh-fJwGme0dZItPf_fjuum0WIsuXv0hVgzmlJcc8IxhFkkOCE7nEWnLsNP6rqRB2psm76q/pub?embedded=true" />
    ),
  },
];
